import React from 'react';
import DatePicker from 'react-datepicker';
import Panel from '../../../common/layout/Panel'
import { useState, useEffect } from 'react';
import { getList } from '../../../common/v4/BackendProvider';
import Table from '../../../common/Table';
import SelectContainer from '../../../common/SelectContainer';
import AsyncSelectContainer from '../../../common/AsyncSelectContainer';

const SmsSummary = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const today = new Date();
    const [d1, setD1] = useState(new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0));
    const [d2, setD2] = useState(new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59));
    
    // Filter states
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedOriginatingCarrier, setSelectedOriginatingCarrier] = useState(null);
    const [selectedTerminatingCarrier, setSelectedTerminatingCarrier] = useState(null);
    const [selectedDestination, setSelectedDestination] = useState(null);
    const [selectedDirection, setSelectedDirection] = useState(null);
    const [selectedGroupByPeriod, setSelectedGroupByPeriod] = useState('day');

    const [originatingCarrierOptions, setOriginatingCarrierOptions] = useState([]);
    const [terminatingCarrierOptions, setTerminatingCarrierOptions] = useState([]);
    const [destinationOptions, setDestinationOptions] = useState([]);
    const [directionOptions, setDirectionOptions] = useState([]);

    // Function to load clients dynamically based on search term
    const loadClients = async (inputValue) => {
        try {
            // If no input value, load initial results (first 50 clients)
            const params = inputValue ? [
                { key: 'search', value: inputValue },
                { key: 'limit', value: 50 }
            ] : [
                { key: 'limit', value: 50 }
            ];
            
            const response = await getList('/admin/clients/clients', params);
            
            if (response.data?.result === 'OK') {
                // Convert to array format with value and label
                const clients = response.data.data.map(client => ({
                    value: client.ATRCLIENTID,
                    label: `${client.ATRACCTNAME} (${client.ATRCLIENTIDNUMBER})`
                }));
                return clients;
            }
            return [];
        } catch (error) {
            console.error('Error loading clients:', error);
            return [];
        }
    };

    const fetchData = () => {
        setLoading(true);
        const params = [
            {key: 'search', value: ''},
            {key: 'start_time_from', value: d1.toISOString()},
            {key: 'start_time_to', value: d2.toISOString()},
        ];

        // Add filter parameters if selected
        if (selectedClient) params.push({key: 'client_id', value: selectedClient});
        if (selectedOriginatingCarrier) params.push({key: 'originating_carrier_id', value: selectedOriginatingCarrier});
        if (selectedTerminatingCarrier) params.push({key: 'terminating_carrier_id', value: selectedTerminatingCarrier});
        if (selectedDestination) params.push({key: 'destination', value: selectedDestination});
        if (selectedDirection) params.push({key: 'direction', value: selectedDirection});
        if (selectedGroupByPeriod) params.push({key: 'group_by_period', value: selectedGroupByPeriod});

        getList('/admin/reports/sms/summary', params)
            .then(result => {
                setData(result.data.data);
                setOriginatingCarrierOptions(result.data?.metadata?.originating_carrier_id?.values);
                setTerminatingCarrierOptions(result.data?.metadata?.terminating_carrier_id?.values);
                setDestinationOptions(result.data?.metadata?.destination?.values);
                setDirectionOptions(result.metadata?.direction?.values);
            })
            .catch(error => console.error('Error:', error))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchData();
    }, []);

    const columns = [
        {
            label: 'Date',
            source: 'ATRDATE',
            type: 'text',
        },
        // {
        //     label: 'Client',
        //     source: 'CLIENT_NAME',
        //     type: 'text'
        // },
        // {
        //     label: 'Destination',
        //     source: 'DESTINATION',
        //     type: 'text'
        // },
        {
            label: 'Msg Count',
            source: 'MESSAGES_COUNT',
            type: 'text'
        },
        {
            label: 'Msg Part Count',
            source: 'MESSAGES_PARTS_COUNT',
            type: 'text'
        },
        {
            label: 'Sell Amount',
            source: 'SELL_AMOUNT',
            type: 'money2'
        },
        {
            label: 'Sell Currency',
            source: 'SELL_CURRENCY_NAME',
            type: 'text'
        },
        {
            label: 'Buy Amount',
            source: 'COST_AMOUNT',
            type: 'money2'
        },
        {
            label: 'Profit',
            source: 'PROFIT',
            type: 'money2'
        }
    ];


    const handleDateRangeFromChange = (value) => {
        setD1(value);
    };

    const handleDateRangeToChange = (value) => {
        setD2(value);
    };

    const handleSearch = () => {
        fetchData();
    };

    const handleFilterChange = (filterType, value) => {
        switch (filterType) {
            case 'client':
                setSelectedClient(value);
                break;
            case 'originatingCarrier':
                setSelectedOriginatingCarrier(value);
                break;
            case 'terminatingCarrier':
                setSelectedTerminatingCarrier(value);
                break;
            case 'destination':
                setSelectedDestination(value);
                break;
            case 'direction':
                setSelectedDirection(value);
                break;
            case 'groupByPeriod':
                setSelectedGroupByPeriod(value);
                break;
        }
    };

    return (
        <div>
           <Panel title="SMS Summary">
            <>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <label className="col-sm-1 control-label">From</label>
                        <div className="col-sm-3">
                            <DatePicker
                                className="form-control datepicker"
                                selected={d1}
                                onChange={handleDateRangeFromChange}
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="yyyy-MM-dd HH:mm"
                            />
                        </div>
                        <label className="col-sm-1 control-label">To</label>
                        <div className="col-sm-3">
                            <DatePicker
                                className="form-control datepicker"
                                selected={d2}
                                onChange={handleDateRangeToChange}
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="yyyy-MM-dd HH:mm"
                            />
                        </div>
                        <div className="col-sm-1">
                            <button className="btn btn-primary" onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                </div>
                
                {/* Filters Row */}
                <div className="row" style={{marginBottom: '15px'}}>
                    <div className="col-md-2">
                        <label className="control-label">Client</label>
                        <AsyncSelectContainer
                            value={selectedClient}
                            onChange={(id, value) => handleFilterChange('client', value)}
                            loadOptions={loadClients}
                            placeholder="Type to search clients..."
                            isClearable={true}
                            defaultOptions={true}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="control-label">Originating Carrier</label>
                        <SelectContainer
                            value={selectedOriginatingCarrier}
                            onChange={(id, value) => handleFilterChange('originatingCarrier', value)}
                            options={originatingCarrierOptions}
                            placeholder="All Carriers"
                            allowNull={true}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="control-label">Terminating Carrier</label>
                        <SelectContainer
                            value={selectedTerminatingCarrier}
                            onChange={(id, value) => handleFilterChange('terminatingCarrier', value)}
                            options={terminatingCarrierOptions}
                            placeholder="All Carriers"
                            allowNull={true}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="control-label">Destination</label>
                        <SelectContainer
                            value={selectedDestination}
                            onChange={(id, value) => handleFilterChange('destination', value)}
                            options={destinationOptions}
                            placeholder="All Destinations"
                            allowNull={true}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="control-label">Direction</label>
                        <SelectContainer
                            value={selectedDirection}
                            onChange={(id, value) => handleFilterChange('direction', value)}
                            options={[
                                {value: null, label: 'All'},
                                {value: 'out', label: 'MT'},
                                {value: 'in', label: 'MO'}
                            ]}
                            placeholder="All Directions"
                            allowNull={true}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="control-label">Group By Period</label>
                        <SelectContainer
                            value={selectedGroupByPeriod}
                            onChange={(id, value) => handleFilterChange('groupByPeriod', value)}
                            options={[
                                {value: 'hour', label: 'Hour'},
                                {value: 'day', label: 'Day'},
                                {value: 'month', label: 'Month'}
                            ]}
                            placeholder="Select Period"
                            allowNull={false}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="btn-group" role="group" style={{marginBottom: '15px'}}>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-outline-secondary"
                                style={{marginRight: '5px'}}
                                onClick={() => {
                                    const today = new Date();
                                    setD1(new Date(today.getFullYear(), today.getMonth() - 1, 1, 0, 0, 0));
                                    setD2(new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59));
                                }}
                            >
                                Last Month
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-outline-secondary"
                                style={{marginRight: '5px'}}
                                onClick={() => {
                                    const today = new Date();
                                    setD1(new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0));
                                    setD2(new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59));
                                }}
                            >
                                Current Month
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-outline-secondary"
                                style={{marginRight: '5px'}}
                                onClick={() => {
                                    const today = new Date();
                                    const yesterday = new Date(today);
                                    yesterday.setDate(today.getDate() - 1);
                                    setD1(new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0));
                                    setD2(new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59));
                                }}
                            >
                                Yesterday
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => {
                                    const today = new Date();
                                    setD1(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0));
                                    setD2(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59));
                                }}
                            >
                                Today
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <Table
                            data={data}
                            metadata={columns}
                            loading={loading}
                            id="mt-table"
                            totals={[
                                { value: 'Total', align: 'left' },
                       //         { value: '', align: 'center' },
                       //         { value: '', align: 'center' },
                                { value: data.reduce((acc, row) => acc + parseFloat(row.MESSAGES_COUNT || 0), 0), align: 'center' },
                                { value: data.reduce((acc, row) => acc + parseFloat(row.MESSAGES_PARTS_COUNT || 0), 0), align: 'center' },
                                { value: data.reduce((acc, row) => acc + parseFloat(row.SELL_AMOUNT || 0), 0).toFixed(2), align: 'right' },
                                { value: '', align: 'center' },
                                { value: data.reduce((acc, row) => acc + parseFloat(row.COST_AMOUNT || 0), 0).toFixed(2), align: 'right' },
                                { value: data.reduce((acc, row) => acc + parseFloat(row.PROFIT || 0), 0).toFixed(2), align: 'right' }
                            ]}
                        />
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-md-12">
                        <div className="card" style={{border: '1px solid #ddd', backgroundColor: '#f8f9fa'}}>
                            <div className="card-body" style={{backgroundColor: '#f8f9fa', paddingLeft: '20px'}}>
                                <h5 className="card-title">Total</h5>
                                <p className="card-text">
                                    <strong>Total Amount:</strong> {data.reduce((acc, row) => acc + parseFloat(row.SELL_AMOUNT || 0), 0).toFixed(2)}
                                </p>
                            </div>
                        </div>
                    </div>
                </div> */}
            </>
            </Panel>
        </div>
    );
};

export default SmsSummary;